<template>
  <div class="table-box card-base card-shadow--medium">
    <el-table
      :data="contracts"
      border
      fit
      stripe
      lazy
      style="width: 100%"
      v-loading="loading"
      ref="table"
    >
      <el-table-column
        label="NO"
        prop="RowId"
        column-key="RowId"
        sortable
        fixed
        width="70"
      />
      <el-table-column
        label="Numero Contrato"
        sort-by="ContractNumber"
        column-key="ContractNumber"
        prop="ContractNumber"
        sortable
      />
      <el-table-column
        label="Codigo Cliente"
        sort-by="ClientNumber"
        column-key="ClientNumber"
        prop="ClientNumber"
        sortable
      />
      <el-table-column
        label="Nombre Cliente"
        sort-by="ClientName"
        column-key="ClientName"
        prop="ClientName"
        sortable
      >
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="callCustomerDetails(scope.$index, contracts)"
            type="text"
            size="small"
          >
            {{ scope.row.ClientName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="Descripción Contrato"
        sort-by="ContractDescription"
        column-key="ContractDescription"
        prop="ContractDescription"
        sortable
      />
      <el-table-column
        label="Moneda"
        sort-by="Currency.Name"
        column-key="Currency.Name"
        prop="Currency.Name"
        sortable
      />
      <!-- <el-table-column
        label="Monto"
        sort-by="UnitPrice"
        column-key="UnitPrice"
        prop= "UnitPrice"
        sortable
        width="100"
      /> -->
      <el-table-column
        label="Monto"
        prop="UnitPrice"
        column-key="UnitPrice"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.UnitPrice">
            {{ formatMonto(scope.row.UnitPrice) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        label="P. Unitario"
        sort-by="Quantity"
        column-key="Quantity"
        prop="Quantity"
        sortable
        width="115"
      />

      <el-table-column
        label="Cantidad"
        sort-by="ServiceQuantity"
        column-key="ServiceQuantity"
        prop="ServiceQuantity"
        sortable
        width="115"
      />
    </el-table>

    <el-pagination
      :hide-on-single-page="pagination.currentPage <= 1"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="pagination.total"
      style="margin: 10px"
    />

    <customer-detail ref="details" />
  </div>
</template>

<script>
export default {
  name: "DealTable",
  components: {
    "customer-detail": () =>
      import(
        /* webpackChunkName: "CustomerDetail" */ "@/components/customers/CustomerDetail.vue"
      )
  },
  props: {
    StatusContract: {
      type: String
    },
    SellerId: {
      type: String,
      default: ""
    },
    filters: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      activeName: "",
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      contracts: []
    };
  },
  methods: {
    callCustomerDetails(index, rows) {
      this.loading = true;

      const parameters = {
        "criteria.companyId": this.currentCompany,
        "criteria.name": rows[index].Name ?? undefined,
        "criteria.vatRegistrationNumber":
          rows[index].VatRegistrationNumber ?? undefined,
        "criteria.clasificaction": rows[index].clasificaction ?? undefined,
        "criteria.contract": rows[index].contract ?? undefined,
        "criteria.clientId": rows[index].ClientNumber ?? undefined
      };

      this.$http
        .get("/api/customers/getCustomerByCriteria", {
          params: parameters
        })
        .then((resp) => {
          this.loading = false;
          this.$refs.details.show(resp.data);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getData(Status) {
      this.loading = true;
      this.activeName = Status;

      let CustomerId = String(this.filters?.CustomerId || "");
      let SellerId = String(this.filters?.SellerId || "");
      let CustomerServiceId = String(this.filters?.CustomerServiceId || "");
      let PaymentAgentId = String(this.filters?.PaymentAgentId || "");

      if (SellerId == "4") {
        SellerId = "04";
      }

      if (CustomerServiceId == "85") {
        CustomerServiceId = "026";
      } else if (CustomerServiceId == "168") {
        CustomerServiceId = "027";
      } else if (CustomerServiceId == "48") {
        CustomerServiceId = "42";
      } else if (CustomerServiceId == "231") {
        CustomerServiceId = "08";
      } else if (CustomerServiceId == "245") {
        CustomerServiceId = "98";
      } else if (CustomerServiceId == "1365") {
        CustomerServiceId = "29";
      }

      this.$http
        .get("/api/contracts", {
          params: {
            CompanyCode: this.currentCompany,
            Page: this.pagination.currentPage,
            Skip: 0,
            Limit: this.pagination.pageSize,
            Status: this.StatusContract,
            ProductName: Status,
            Option: "H",
            CustomerCode: CustomerId,
            SellerCode: SellerId,
            CustomerServiceCode: CustomerServiceId,
            PaymentAgentCode: PaymentAgentId
          },
          Headers: {
            "Content-Type": "application/json"
          }
        })
        .then((resp) => {
          this.loading = false;
          this.contracts = resp.data.Items;
          this.pagination.total = resp.data.ItemCount;
          this.pagination.currentPage = resp.data.CurrentPage;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatMonto(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData(this.activeName);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getData(this.activeName);
    },
    formatDate(date, toFormat = "DD/MM/YYYY hh:mm:ss") {
      // date => "2020-06-25T10:54:07.28" or "2020-06-25T10:54:07.280"
      let format = "YYYY-MM-DDTHH:mm:ss.SS";

      if (date.length === 23) {
        format = "YYYY-MM-DDTHH:mm:ss.SSS";
      }
      let mDate = this.$moment(date, format);

      if (mDate.isValid()) {
        return mDate.format(toFormat);
      }
      return "";
    },
    handleCommand(c) {
      switch (c.command) {
        case "view": {
          break;
        }

        case "edit":
          break;

        case "delete":
          break;

        default:
          break;
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: false,
      handler() {
        this.pagination.currentPage = 1;
        this.getData(this.activeName);
      }
    },
    StatusContract() {
      this.getData(this.activeName);
    }
  }
};
</script>

<style></style>
